import { ReactNode } from "react";
import { Typography, Flex, Skeleton } from "antd";

export const Section = ({
  title,
  children,
  bordered,
  extra,
}: {
  title: string;
  children: ReactNode;
  bordered?: boolean | "bottom" | "top";
  extra?: ReactNode;
}) => {
  return (
    <div className={`px-1 pt-4 pb-2 ${bordered === true ? "border-0 border-t border-solid border-gray-300/80" : ""}`}>
      <Flex className="justify-between">
        <Typography.Title level={5} className="!mb-4 uppercase !text-sm !text-gray-500/90">
          {title}
        </Typography.Title>
        {extra}
      </Flex>
      <div className="px-2">{children}</div>
    </div>
  );
};

export const StatCard = ({
  label,
  text,
  subtext,
  loading,
}: {
  label: string;
  text: string;
  subtext?: string;
  loading?: boolean;
}) => {
  if (loading) {
    return (
      <Flex vertical className="w-full min-h-16" gap={4}>
        <Skeleton.Input active size="small" style={{ width: 90, height: 14 }} />
        <Skeleton.Input active size="small" style={{ width: 140, height: 24, marginTop: 4 }} />
        <Skeleton.Input active size="small" style={{ width: 110, height: 12, marginTop: 2 }} />
      </Flex>
    );
  }

  return (
    <Flex vertical className="w-full min-h-16">
      <Typography.Text className="!text-sm">{label}</Typography.Text>
      <Typography.Title level={4} className="!m-0">
        {text}
      </Typography.Title>
      {subtext?.length && <span className="!text-xs !text-gray-500">{subtext}</span>}
    </Flex>
  );
};
